import Cookies from 'js-cookie';
import { palette } from './palette';

// ----------------------------------------------------------------------

type ThemeMode = 'light' | 'dark';

export function darkMode(mode: ThemeMode) {
  const theme = {
    palette: palette(mode),
  };

  return theme;
}

export function checkCookiesMode(): ThemeMode {
  const cookiesMode = Cookies.get('theme') as ThemeMode;
  if (cookiesMode) {
    return cookiesMode;
  }
  return 'light';
}

export function changeCookiesMode(mode: ThemeMode): void {
  const cookiesMode = Cookies.get('theme');
  if (cookiesMode) {
    Cookies.remove('theme');
  }
  Cookies.set('theme', mode, { expires: 365 });
}
